import { AddressProps } from "./address.model";
import { CompanyProps } from "./company.model";
import { DeveloperPackageProps } from "./developer-package.model";
import { DeveloperProps } from "./developer.model";
import { FilterModel } from "./enum";
import { ResponseProps } from "./response";

export type SolicitationProps = {
  address: AddressProps;
  developer?: DeveloperProps;
  company?: CompanyProps;
  developerCompany: {
    company: CompanyProps;
    developer: DeveloperProps;
    id: number;
  };
  developerPackage: DeveloperPackageProps;
  id: number;
  status: "FINISHED";
  type: "COMPANY" | "BASIC_REGISTER" | "COMPANY_REGISTER" | "PACKAGE";
  createdAt: string;
};
export const typeRequest = {
  PERSONAL_DATA: "PERSONAL_DATA",
  REGISTER: "REGISTER",
  COMPANY: "COMPANY",
  BASIC_REGISTER: "BASIC_REGISTER",
  COMPANY_REGISTER: "COMPANY_REGISTER",
  PACKAGE: "PACKAGE",
};

export interface SolicitationResponseModel extends ResponseProps {
  content: SolicitationProps[];
}

export interface Solicitation {
  load: (params: FilterModel) => Promise<SolicitationResponseModel>;
  loadById: (id: number) => Promise<SolicitationProps>;
  create: (body: SolicitationProps) => Promise<SolicitationProps>;
  update: (id: number, body: SolicitationProps) => Promise<SolicitationProps>;
  count: () => Promise<number>;
  complete: (id: number | undefined) => Promise<SolicitationProps>;
  delete(id?: number): Promise<SolicitationProps>;
  exportCSV: (params: FilterModel) => Promise<void>;
}
